import { EMPTY_OBJECT, EMPTY_STRING } from '../constants';

class RenderConfig {
	params: any;

	name: any;

	id: string;

	label: any;

	renderProps: any;

	renderer: any;

	toolTip: any;

	isCollapsible: boolean;

	description: string;

	constructor(params?: any) {
		this.params = params;
		this.name = null;
		this.id = '';
		this.label = null;
		this.renderProps = EMPTY_OBJECT;
		this.renderer = null;
		this.toolTip = null;
		this.isCollapsible = false;
		this.description = EMPTY_STRING;
	}

	setDescription = (description: string) => {
		this.description = description;
		return this;
	};

	getDescription = () => this.description;

	setToolTip = (toolTip: any) => {
		this.toolTip = toolTip;
		return this;
	};

	getToolTip = () => this.toolTip;

	setName = (name: any) => {
		this.name = name;
		return this;
	};

	setId = (name: string) => {
		this.id = name;
		return this;
	};

	getName = () => this.name;

	setLabel = (label: any) => {
		this.label = label;
		return this;
	};

	getLabel = () => this.label;

	setRenderProps = (renderProps: any) => {
		this.renderProps = { ...this.renderProps, ...renderProps };
		return this;
	};

	getRenderProps = () => this.renderProps;

	setRenderer = (renderer: any) => {
		this.renderer = renderer;
		return this;
	};

	getRenderer = () => this.renderer;

	setIsCollapsible = (isCollapsible: boolean) => {
		this.isCollapsible = isCollapsible;
		return this;
	};

	getIsCollapsible = () => this.isCollapsible;
}

export default RenderConfig;
